import { DataCenter } from "./DataCenter";
import * as consts from "./play/const";
const loadRemoteScript = (url: string, callback?: () => void) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = () => {
        console.log('script loaded');
        callback?.();
    };
    script.onerror = () => {
        console.error('script load failed');
    };
    document.body.appendChild(script);
};

export async function Init(call?: () => void) {
    loadRemoteScript('https://sdk.crazygames.com/crazygames-sdk-v3.js', async () => {        
        await window.CrazyGames.SDK.init();
        call?.();
    });
}
let gameState = 0;
export function gameStart() {
    if(gameState != 1)
        window.CrazyGames.SDK.game.gameplayStart();
    gameState = 1;
}
export async function gameStop() {
    if(gameState != 2)
        window.CrazyGames.SDK.game.gameplayStop();
    gameState = 2;
}

export function loadingStart() {
    window.CrazyGames.SDK.game.loadingStart();
}
export function loadingStop() {
    window.CrazyGames.SDK.game.loadingStop();
}

export function happyTime() {
    window.CrazyGames.SDK.game.happytime();
}

export function ClearData() {
    window.CrazyGames.SDK.data.clear();
}
export function SetItem(key: string, value: any) {
    window.CrazyGames.SDK.data.setItem(key, value);
}
export function GetItem(key: string): any {
    return window.CrazyGames.SDK.data.getItem(key);
}
export function RemoveItem(key: string) {
    window.CrazyGames.SDK.data.removeItem(key);
}

//midgame or rewarded
export function ShowAd(type: string, call?: () => void, fail?: () => void) {
    if(type == "") {
        call?.();
        return;
    }
    const callbacks = {
        adFinished: () => {
            console.log("End ad");
            Laya.SoundManager.musicMuted = false;
            call?.();
        },
        adError: (error) => {
            console.log("Error ad", error);
            Laya.SoundManager.musicMuted = false;
            fail?.();
        },
        adStarted: () => {
            console.log("Start ad");
            Laya.SoundManager.musicMuted = true;
        },
    };
    window.CrazyGames.SDK.ad.requestAd(type, callbacks);
}

export function ShowInterstitialAd(call?: () => void) {
    ShowAd("midgame", () => {
        console.log("Interstitial ad finished");
        call?.();
    }, () => {
        console.log("Interstitial ad failed");
        call?.();
    });
}


export function Login(call?: () => void) {
    DataCenter.instance.level_info = [1,1,1];
    for(let i = 0; i < consts.MODE_NAMES.length; i++) {
        let key = consts.MODE_NAMES[i];
        DataCenter.instance.level_info[i] = GetItem(key) || 1;
    }
    const available = window.CrazyGames.SDK.user.isUserAccountAvailable;
    if(available) {
        window.CrazyGames.SDK.user.getUser().then((user) => {
            if(user)
            {
                DataCenter.instance.user_name = user.username;
                DataCenter.instance.user_pic = user.profilePictureUrl;
            }
            call?.();
        }).catch((err) => {
            console.error("Get user failed", err);
        });
    }
    else {
        call?.(false);
    }
    return "null";
}